import React from 'react';
import { Bar, BarChart, ResponsiveContainer, Tooltip, XAxis } from 'recharts';
import styled from 'styled-components';
import theme from '@styles/theme';

type BarChartProps = {
    data: any;
};

const StickChart = ({ data }: BarChartProps) => {
    const getPath = (x: number, y: number, width: number, height: number) => {
        const radius = 4;

        if (height === 0) {
            return '';
        }

        return `
            M${x + radius},${y}
            H${x + width - radius}
            Q${x + width},${y} ${x + width},${y + radius}
            V${y + height}
            H${x}
            V${y + radius}
            Q${x},${y} ${x + radius},${y}
            Z
        `;
    };

    return (
        <ResponsiveContainer width="100%" height="100%">
            <StyledBarChart
                data={data}
                margin={{
                    top: 0,
                    right: -10,
                    left: -10,
                    bottom: 0
                }}
                barSize={13}
            >
                <XAxis
                    dataKey="name"
                    padding={{ left: 10, right: 10 }}
                    tickLine={false}
                    tick={{
                        fill: theme.colors.deepGrayFontColor,
                        style: {
                            backgroundColor: 'transparent'
                        }
                    }}
                    tickMargin={10}
                    axisLine={{
                        stroke: theme.colors.ultraLightGrayBorder,
                        strokeWidth: 1
                    }}
                    fontSize={14}
                />
                <Tooltip
                    formatter={(value) => [`${value?.toLocaleString()}건`]}
                />
                <Bar
                    dataKey="value"
                    fill="#000"
                    shape={(props: any) => {
                        const { fill, x, y, width, height } = props;
                        return (
                            <path
                                d={getPath(x, y, width, height)}
                                stroke="none"
                                fill={fill}
                            />
                        );
                    }}
                />
            </StyledBarChart>
        </ResponsiveContainer>
    );
};

export default StickChart;

const StyledBarChart = styled(BarChart)`
    width: 100%;
    height: 170px;
`;
